import React from 'react'
import { Container } from 'react-bootstrap'
import './../assest/style/Skill.css'
export const Skill = () => {
  return (
    <div className='Skill'>
        <Container>
			<h1>My Skills </h1>
<div className='bigbox'>
    <Container>
  <div className='row'>
    <div className='col-lg-4 col-md-6 col-sm-12'>
	<div class="circle per-92">
    <div class="inner">photoshop</div>
  </div>
    </div>

	<div className='col-lg-4 col-md-6 col-sm-12'>
	<div class="circle per-90">
    <div class="inner">inDesign</div>
  </div>
				</div>


				<div className='col-lg-4 col-md-6 col-sm-12'>
        		<div class="circle per-88">
    <div class="inner">Priemier</div>
  </div>
				</div>


  </div>





  <div className='row'>
    <div className='col-lg-4 col-md-6 col-sm-12'>
	<div class="circle per-100">
    <div class="inner">Office</div>
  </div>	
    </div>

	<div className='col-lg-4 col-md-6 col-sm-12'>
	<div class="circle per-94">
    <div class="inner">illustrator</div>
  </div>
				</div>


				<div className='col-lg-4 col-md-6 col-sm-12'>
        		<div class="circle per-100">
    <div class="inner">Marketing</div>
  </div>
				</div>

				
  </div>
    </Container>
</div>
        </Container>
    </div>
  )
}
